<template>
  <div>
    <Modal title="用户检测" v-model="userCheckModal" width="1000">
      <Spin fix v-if="userChecking"></Spin>
      <Alert type="error" v-else-if="userCheckError" show-icon>检测用户失败</Alert>
      <Alert type="success" v-else-if="userCheckResult.active" show-icon>激活状态有效</Alert>
      <Alert type="warning" v-else show-icon>激活已失效，请点击重新激活</Alert>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="activeSubmit(false)" :loading="activeSubmitting" v-if="!userCheckError && !userCheckResult.active">重新激活</Button>
        <Button @click="userCheckModal = false">取消</Button>
      </div>
    </Modal>
    <Modal title="用户编辑" v-model="updateUserModal" width="1000">
      <Form ref="updateUserForm" :model="updateUserForm" :rules="updateUserRules">
        <FormItem label="状态" style="width: 100%" prop="enabled">
          <i-switch v-model="updateUserForm.enabled" size="large">
            <span slot="open">可用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem label="登陆后默认选中的租户" style="width: 100%" prop="default_project_id">
          <Select v-model="updateUserForm.default_project_id" placeholder="选择登陆后默认选中的租户" filterable transfer>
            <Option v-for="item in projects" :key="item.id" :value="item.id" v-if="item.enabled">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="updateUserSubmit" :loading="updateUserSubmitting">更新</Button>
        <Button @click="updateUserModal = false">取消</Button>
      </div>
    </Modal>
    <Modal title="激活用户" v-model="activeModal" width="1000">
      <Form ref="activeForm" :model="activeForm" :rules="activeRules">
        <FormItem label="用户" style="width: 100%" prop="user_id">
          <Select v-model="activeForm.user_id" placeholder="选择要激活的用户" filterable transfer>
            <Option v-for="item in opsUserList" :key="item.id" :value="item.id" v-if="item.is_active">{{ item.name ? (`${item.name} (${item.username})`) : item.username }}</Option>
          </Select>
        </FormItem>
        <FormItem label="登陆后默认选中的租户" style="width: 100%" prop="default_project_id">
          <Select v-model="activeForm.default_project_id" placeholder="选择登陆后默认选中的租户" filterable transfer>
            <Option v-for="item in projects" :key="item.id" :value="item.id" v-if="item.enabled">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="activeSubmit" :loading="activeSubmitting">激活</Button>
        <Button @click="activeModal = false">取消</Button>
      </div>
    </Modal>
    <Modal title="授权租户" v-model="assignProjectModal" width="1000">
      <Spin fix v-if="getRoleAssignmentsLoading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
      <Alert v-else-if="assignProjectsError" show-icon type="error">
        获取数据失败
      </Alert>
      <div v-else>
        <div v-for="(projectItem, index) in assignProjects" :key="index">
          <Form ref="projectForm" :model="projectItem" :rules="assignProjectRules" inline>
            <Row>
              <FormItem prop="project" :label-width="50" label="租户">
                <Select v-model="projectItem.project" placeholder="租户" clearable style="width: 200px" @on-change="projectChange">
                  <Option v-for="pItem in projects" :key="pItem.id" :value="pItem.id">{{ pItem.name }}</Option>
                </Select>
              </FormItem>
              <FormItem prop="roles" :label-width="50" label="角色">
                <Select v-model="projectItem.roles" placeholder="角色" multiple clearable style="width: 400px">
                  <Option v-for="roleItem in roles" :key="roleItem.id" :value="roleItem.id">{{ roleItem.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="5">
                <a v-on:click="removeAssignProjectItem(index)">
                  <Icon type="md-close" size="15" />
                </a>
              </FormItem>
            </Row>
          </Form>
        </div>
        <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addAssignProjectItem"></Button>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="assignProjectSubmit" :loading="assignProjectSubmitting">提交</Button>
        <Button @click="assignProjectModal = false">取消</Button>
      </div>
    </Modal>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a v-on:click="getUsers()" style="float: right"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row>
            <h4 style="float: left">已激活用户</h4>
            <div style="float: right;" class="align-right">
              <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getUsers(page)">刷新</Button>
              <Button
                @click="activeModal = true"
                :style="{marginBottom: '10px'}"
                icon="md-add">激活用户</Button>
            </div>
          </Row>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="users"
            :columns="columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: left;">
              当前显示 {{ users.length }} 条记录，总共 {{ count }} 条记录
            </div>
            <div style="float: right;">
              <page
                :total="count"
                :current="page"
                :page-size="size"
                @on-change="getUsers"></page>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudProject } from '@/api/private-cloud/project'
import { getPrivateCloudRole, getPrivateCloudRoleAssignments } from '@/api/private-cloud/role'
import { getPrivateCloudUser, activePrivateCloudUser, assignProjectPrivateCloud, checkPrivateCloudUserActive,
  updatePrivateCloudUser, cancelActivePrivateCloudUser } from '@/api/private-cloud/user'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'user',
  data () {
    return {
      error: false,
      users: [],
      columns: [
        {
          title: '用户名',
          key: 'username',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            if (params.row.user_info) {
              return h('span', params.row.user_info.username)
            }
          }
        },
        {
          title: '姓名',
          key: 'name',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.user_info) {
              return h('span', params.row.user_info.name)
            }
          }
        },
        {
          title: '邮箱',
          key: 'email',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            if (params.row.user_info) {
              return h('span', params.row.user_info.email)
            }
          }
        },
        {
          title: '状态',
          key: 'enabled',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.enabled) {
              return h('Tag', {
                attrs: {
                  color: 'cyan'
                }
              }, '可用')
            } else {
              return h('Tag', {
                attrs: {
                  color: 'red'
                }
              }, '禁用')
            }
          }
        },
        {
          title: '可登陆检测',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.activeForm.user_id = params.row.user_info.id
                    this.activeForm.default_project_id = params.row.default_project_id
                    this.userCheckResult = {}
                    this.userCheckModal = true
                    this.checkUserActive(params.row.user_info.id)
                  }
                }
              }, '立即检测')
            ])
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.updateUserForm.id = params.row.id
                    this.updateUserForm.enabled = params.row.enabled
                    this.updateUserForm.default_project_id = params.row.default_project_id
                    if (params.row.user_info) {
                      this.updateUserForm.ops_user_id = params.row.user_info.id
                    }
                    this.updateUserModal = true
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.assignUserId = params.row.id
                    this.assignProjectModal = true
                    this.getRoleAssignments(params.row.id)
                  }
                }
              }, '分配租户'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  transfer: true,
                  title: '你确定要取消激活该用户吗？'
                },
                on: {
                  'on-ok': () => {
                    this.cancelActiveSubmit(params.row.id, params.row.user_info)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '取消激活')
              ])
            ])
          }
        }
      ],
      page: 1,
      size: 15,
      count: 0,
      tableLoading: false,
      // 激活用户
      activeModal: false,
      activeForm: {
        user_id: null,
        default_project_id: ''
      },
      activeRules: {
        user_id: { required: true, message: '请选择要激活的用户', type: 'number', trigger: 'change' }
      },
      activeSubmitting: false,
      // 检测用户
      userCheckModal: false,
      userCheckResult: {},
      userCheckError: false,
      userChecking: false,
      // 编辑用户
      updateUserModal: false,
      updateUserForm: {
        id: null,
        ops_user_id: null,
        enabled: true,
        default_project_id: ''
      },
      updateUserRules: {
        enabled: { required: true, message: '', type: 'boolean', trigger: 'change' }
      },
      updateUserSubmitting: false,
      // OPS用户列表
      opsUserList: [],
      // 租户列表
      projects: [],
      // 角色列表
      roles: [],
      // 分配租户
      assignProjectModal: false,
      getRoleAssignmentsLoading: false,
      assignProjectsError: false,
      assignUserId: '',
      assignProjects: [],
      assignProjectRules: {
        project: { required: true, message: '', trigger: 'change', validator: this.validProjectForm },
        roles: { required: true, message: '请选择授权的角色', type: 'array' }
      },
      assignProjectSubmitting: false
    }
  },
  created: function () {
    this.getAllOpsUserData()
    this.getUsers()
    this.getProjects()
    this.getRoles()
  },
  methods: {
    getUsers (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        size: this.size
      }
      this.error = false
      this.tableLoading = true
      getPrivateCloudUser(params).then(res => {
        this.users = res.data.results
        this.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    },
    // 获取所有用户数据
    getAllOpsUserData () {
      GetALLUsers().then(res => {
        this.opsUserList = res.data
      })
    },
    // 获取所有租户
    getProjects () {
      getPrivateCloudProject().then(res => {
        this.projects = res.data.projects
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 获取所有角色
    getRoles () {
      getPrivateCloudRole().then(res => {
        this.roles = res.data.roles
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 激活
    activeSubmit (isNew = true) {
      if (isNew) {
        this.$refs.activeForm.validate((valid) => {
          if (!valid) {
            return false
          }
        })
      }
      this.activeSubmitting = true
      activePrivateCloudUser(this.activeForm).then(res => {
        this.$Notice.success({title: '激活成功'})
        this.activeModal = false
        this.userCheckModal = false
        this.getUsers()
        this.activeSubmitting = false
        this.$refs.activeForm.resetFields()
      }).catch(res => {
        this.activeSubmitting = false
        console.error(res.response)
        if (res.response && res.response.data) {
          this.$Notice.error({
            title: '激活失败',
            desc: res.response.data
          })
        } else {
          this.$Notice.error({title: '激活失败'})
        }
      })
    },
    // 取消激活
    cancelActiveSubmit (id, opsUser) {
      let reqData = {}
      if (opsUser.username) {
        reqData.ops_username = opsUser.username
      }
      cancelActivePrivateCloudUser(id, reqData).then(res => {
        this.$Notice.success({title: '操作成功'})
        this.getUsers()
      }).catch(res => {
        console.error(res.response)
        if (res.response && res.response.data) {
          this.$Notice.error({
            title: '操作失败',
            desc: res.response.data
          })
        } else {
          this.$Notice.error({title: '操作失败'})
        }
      })
    },
    // 检测用户
    checkUserActive (id) {
      this.userChecking = true
      this.userCheckError = false
      checkPrivateCloudUserActive(id).then(res => {
        this.userChecking = false
        this.userCheckResult = res.data
      }).catch(res => {
        this.userChecking = false
        this.userCheckError = true
        console.log(res.response)
      })
    },
    // 更新用户
    updateUserSubmit () {
      this.$refs.updateUserForm.validate((valid) => {
        if (valid) {
          this.updateUserSubmitting = true
          let reqData = {
            ops_user_id: this.updateUserForm.ops_user_id,
            enabled: this.updateUserForm.enabled,
            default_project_id: this.updateUserForm.default_project_id
          }
          updatePrivateCloudUser(reqData, this.updateUserForm.id).then(res => {
            this.$Notice.success({title: '更新成功'})
            this.updateUserModal = false
            this.getUsers()
            this.updateUserSubmitting = false
            this.$refs.updateUserForm.resetFields()
          }).catch(res => {
            this.updateUserSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: res.response.data ? JSON.stringify(res.response.data) : '更新失败'})
          })
        }
      })
    },
    addAssignProjectItem () {
      this.assignProjects.push({
        project: '',
        roles: []
      })
    },
    removeAssignProjectItem (index) {
      this.assignProjects.splice(index, 1)
    },
    // 获取角色分配情况
    getRoleAssignments (userId) {
      this.assignProjects = []
      let data = {}
      this.getRoleAssignmentsLoading = true
      getPrivateCloudRoleAssignments({user_id: userId}).then(res => {
        let result = res.data.role_assignments
        for (let i in result) {
          if (result[i].scope.project) {
            let projectId = result[i].scope.project.id
            if (data[projectId]) {
              data[projectId].push(result[i].role.id)
            } else {
              data[projectId] = [result[i].role.id]
            }
          }
        }
        for (let i in data) {
          this.assignProjects.push({
            project: i,
            roles: data[i]
          })
        }
        this.getRoleAssignmentsLoading = false
        this.assignProjectsError = false
      }).catch(res => {
        this.getRoleAssignmentsLoading = false
        this.assignProjectsError = true
        console.error(res.response)
      })
    },
    // 分配租户提交
    assignProjectSubmit () {
      let allValid = true
      for (let i in this.$refs.projectForm) {
        this.$refs.projectForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      if (allValid) {
        let reqData = {
          projects: this.assignProjects
        }
        this.assignProjectSubmitting = true
        assignProjectPrivateCloud(reqData, this.assignUserId).then(res => {
          this.assignProjectSubmitting = false
          if (res.data.have_error) {
            this.getRoleAssignments(this.assignUserId)
            this.$Notice.warning({title: '部分租户分配异常, 请检查'})
          } else {
            this.assignUserId = null
            this.assignProjectModal = false
            this.$Notice.success({title: '操作成功'})
          }
        }).catch(res => {
          this.assignProjectSubmitting = false
          console.log(res.response)
          this.$Notice.error({title: res.response.data ? JSON.stringify(res.response.data) : '操作失败'})
        })
      }
    },
    validProjectForm (rule, value, callback) {
      let projectIds = this.assignProjects.map(item => item.project)
      const oneProjectIdIndex = projectIds.indexOf(value)
      if (!value) {
        callback(new Error('请选择要分配的租户！'))
      } else if (oneProjectIdIndex > -1 && oneProjectIdIndex < projectIds.length - 1) {
        if (projectIds.indexOf(value, oneProjectIdIndex + 1) > -1) {
          callback(new Error('不能重复选择此租户！'))
        }
      } else {
        callback()
      }
    },
    projectChange () {
      for (let i in this.$refs.projectForm) {
        this.$refs.projectForm[i].validate()
      }
    }
  }
}
</script>

<style scoped>

</style>
